import {
  uploadLargeFile,
  stuExposureDetUploads,
  getUploadedFileUrl,
} from '../../../shared/services/fileUploadService';

export const EXPOSURE_BUCKET = 'emisapplication';
export const EXPOSURE_IMAGE_PATH = 'student_exposure/images';
export const EXPOSURE_VIDEO_FOLDER = 'videos';

const VIEW_EXPIRY = 3600;

export type ExposureMediaKind = 'image' | 'video';

function buildUniqueName(file: File): string {
  const parts = file.name.split('.');
  const ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  const baseName = parts.slice(0, -1).join('.') || 'file';
  const unique = `${baseName}_${Date.now()}`;
  return ext ? `${unique}.${ext}` : unique;
}

export async function uploadExposureFile(
  kind: ExposureMediaKind,
  _studentId: string | number,
  file: File
): Promise<{ key: string; fileName: string; response: any }> {
  if (kind == 'video') {
    const response = await stuExposureDetUploads(file, EXPOSURE_VIDEO_FOLDER);
    if (!response?.dataStatus) {
      throw new Error(response?.message || 'Upload failed.');
    }
    return {
      key: response?.data?.share_link ?? '',
      fileName: response?.data?.file_name ?? file.name,
      response,
    };
  }

  // Image → large-file upload.
  const fileName = `${EXPOSURE_IMAGE_PATH}/${buildUniqueName(file)}`;
  const response = await uploadLargeFile(file, fileName, EXPOSURE_BUCKET);
  return { key: fileName, fileName, response };
}

export async function viewExposureFile(storedKey: string): Promise<any> {
  if (/^https?:\/\//i.test(storedKey)) return storedKey;
  return getUploadedFileUrl(EXPOSURE_BUCKET, storedKey, VIEW_EXPIRY);
}
